'use client';
import { factory, useWindowSize, Box, Grid, Typography, DsmColor, Flex, omitText } from '@kohler-dsm-library/kohler-core';
import { CloseIcon, ArrowLeftIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React, { useRef, useEffect } from 'react';
import classes from './LoginMenu.module.css.mjs';

const LoginMenu = factory((props, ref) => {
  const {
    className,
    headingSignIn,
    headingSignOut,
    loggedInCTAs,
    loggedOutCTAs,
    signOutCTA,
    isLoggedIn,
    setIsOpenMobileMenu,
    setMenuType,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    userName,
    id = "login-menu",
    ...rest
  } = props;
  const classNames = clsx(className, "kohler-login-menu-root", classes.loginMenu);
  const { width } = useWindowSize();
  const isSmallerScreen = width < 1024;
  const didMountRef = useRef(false);
  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }
    setMenuType?.(null);
    setIsOpenMobileMenu?.(false);
  }, [isLoggedIn, setMenuType, setIsOpenMobileMenu]);
  return /* @__PURE__ */ React.createElement(Box, { id, component: "div", ref, className: classNames, ...rest }, /* @__PURE__ */ React.createElement(Grid, { className: clsx("center-grid", classes.loginMenuGridGap) }, /* @__PURE__ */ React.createElement(Box, { className: classes.loginMenuMobileClose }, /* @__PURE__ */ React.createElement(
    Box,
    {
      component: "button",
      type: "button",
      "aria-label": "close user menu",
      onClick: () => {
        setMenuType?.(null);
        setIsOpenMobileMenu?.(false);
      },
      className: classes.loginMenuMobileCloseIcon
    },
    /* @__PURE__ */ React.createElement(CloseIcon, { withBoundingBox: false, size: "medium" })
  ), /* @__PURE__ */ React.createElement(
    Typography,
    {
      size: "label-regular-m",
      component: "button",
      type: "button",
      textColor: DsmColor.ContentSecondary,
      className: classes.loginMenuMobileBackText,
      onClick: () => setMenuType?.(null)
    },
    /* @__PURE__ */ React.createElement(ArrowLeftIcon, { withBoundingBox: false, size: "small" }),
    " Menu"
  )), /* @__PURE__ */ React.createElement(Flex, { className: classes.loginMenuContent }, isLoggedIn && headingSignIn && /* @__PURE__ */ React.createElement(Typography, { size: "navigation-overlay-title", textColor: DsmColor.ContentPrimary }, headingSignIn.text), !isLoggedIn && headingSignOut && /* @__PURE__ */ React.createElement(Typography, { size: "navigation-overlay-title", textColor: DsmColor.ContentPrimary }, headingSignOut.text)), (loggedInCTAs || loggedOutCTAs) && /* @__PURE__ */ React.createElement("ul", { className: classes.loginMenuContentList }, isLoggedIn && loggedInCTAs && loggedInCTAs.map((CTA) => {
    return /* @__PURE__ */ React.createElement(Flex, { component: "li", key: CTA.text }, /* @__PURE__ */ React.createElement(
      Typography,
      {
        component: "href" in CTA && CTA?.href ? CTA.component ?? "a" : CTA.component ?? "button",
        ...omitText(CTA),
        size: isSmallerScreen ? "navigation-overlay-item-l" : "h6",
        textColor: DsmColor.ContentActionDefault
      },
      CTA.text
    ));
  }), !isLoggedIn && loggedOutCTAs && loggedOutCTAs.map((CTA) => {
    return /* @__PURE__ */ React.createElement(Flex, { component: "li", key: CTA.text }, /* @__PURE__ */ React.createElement(
      Typography,
      {
        component: "href" in CTA && CTA?.href ? CTA.component ?? "a" : CTA.component ?? "button",
        ...omitText(CTA),
        size: isSmallerScreen ? "navigation-overlay-item-l" : "h6",
        textColor: DsmColor.ContentActionDefault
      },
      CTA.text
    ));
  }), isLoggedIn && signOutCTA && /* @__PURE__ */ React.createElement(Flex, { component: "li", className: classes.loginMenuContentListLastItem }, /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: "href" in signOutCTA && signOutCTA?.href ? signOutCTA.component ?? "a" : signOutCTA.component ?? "button",
      ...omitText(signOutCTA),
      size: isSmallerScreen ? "label-regular-l" : "label-regular-m",
      textColor: DsmColor.ContentActionDefault
    },
    signOutCTA.text || "Sign Out"
  )))));
});

export { LoginMenu };
